import React from 'react';

/**
 * Reusable Info Card Component
 * Displays a section of information with a title and content
 */
const InfoCard = ({
    title,
    icon = null,
    children,
    className = '',
    headerAction = null,
    collapsible = false,
    defaultCollapsed = false
}) => {
    const [isCollapsed, setIsCollapsed] = React.useState(defaultCollapsed);

    return (
        <div className={`bg-gray-800 rounded-lg border border-gray-700 overflow-hidden ${className}`}>
            <div
                className={`px-4 py-3 border-b border-gray-700 flex items-center justify-between ${collapsible ? 'cursor-pointer hover:bg-gray-750' : ''}`}
                onClick={() => collapsible && setIsCollapsed(!isCollapsed)}
            >
                <div className="flex items-center gap-2">
                    {icon && <span className="text-lg">{icon}</span>}
                    <h3 className="font-semibold text-white text-sm">{title}</h3>
                </div>
                <div className="flex items-center gap-2">
                    {headerAction}
                    {collapsible && (
                        <svg
                            className={`w-4 h-4 text-gray-400 transition-transform ${isCollapsed ? '' : 'rotate-180'}`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    )}
                </div>
            </div>
            {!isCollapsed && (
                <div className="p-4">
                    {children}
                </div>
            )}
        </div>
    );
};

export default InfoCard;
